import React from "react";
import { BOX, CONTAINER } from "../about/About";
import GitHubCalendar from "react-github-calendar";
import styled from "styled-components";

export const GitCalender = () => {
  return (
    <CONTAINER id="gitStats">
      <BOX>
        <p>Day's I Code</p>
        <h2>My Github Stats</h2>
        <GITSTATS>
          <img
            align="left"
            src="https://github-readme-streak-stats.herokuapp.com/?user=MitreshPrajapati&theme=dark"
            alt="Mitresh"
            height="250px"
            
          />
          <img
            align="right"
            src="https://github-readme-stats.vercel.app/api?username=MitreshPrajapati&show_icons=true&theme=dark"
            height="255px"
            
          />
        </GITSTATS>

        <GITCAL style={{ width: "75%", height: "100%", margin: "auto" }}>
          <GitHubCalendar
            username="MitreshPrajapati"
            showWeekdayLabels="true"
          />
        </GITCAL>
      </BOX>
    </CONTAINER>
  );
};

const GITSTATS = styled.div`
 display: flex;
 gap: 1rem;
 margin: auto;
 img{
  width: 47%;
  margin: auto;
  // filter:drop-shadow( blue  2px 2px 0.5rem);
  @media screen and (min-width: 300px) and (max-width: 767px){
      width: 70%;
      height: 70%;
  }
}

 @media screen and (min-width: 300px) and (max-width: 767px){
  flex-direction: column;
 
 }
`
const GITCAL = styled.div`
 display: flex;
 margin: auto;
 padding-top: 2rem;

`
